import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const ConfirmContext = createContext();

export const ConfirmProvider = ({ children }) => {
  const [dialog, setDialog] = useState(null);

  // altLabel adds an optional third button for choices that aren't yes/no
  // (e.g. "apply to everyone" vs "just this one"). It resolves to the string
  // 'alt'; callers that don't pass it keep the plain true/false contract.
  const confirm = useCallback((message, { title = 'Confirm', confirmLabel = 'Confirm', altLabel = null, danger = false } = {}) => {
    return new Promise(resolve => {
      setDialog({ message, title, confirmLabel, altLabel, danger, resolve });
    });
  }, []);

  const handleConfirm = () => {
    dialog?.resolve(true);
    setDialog(null);
  };

  const handleAlt = () => {
    dialog?.resolve('alt');
    setDialog(null);
  };

  const handleCancel = useCallback(() => {
    dialog?.resolve(false);
    setDialog(null);
  }, [dialog]);

  useEffect(() => {
    if (!dialog) return;
    const fn = (e) => { if (e.key === 'Escape') handleCancel(); };
    document.addEventListener('keydown', fn);
    return () => document.removeEventListener('keydown', fn);
  }, [dialog, handleCancel]);

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {dialog && (
        <div
          className="modal-overlay"
          onClick={handleCancel}
          style={{ zIndex: 2000 }}
        >
          <div
            className="modal"
            onClick={e => e.stopPropagation()}
            style={{ maxWidth: '420px', width: '90vw' }}
          >
            <h3 style={{ marginBottom: 'var(--spacing-sm)' }}>{dialog.title}</h3>
            <p style={{ color: 'var(--color-secondary)', fontSize: 'var(--font-size-sm)', marginBottom: 'var(--spacing-lg)', lineHeight: 1.5 }}>
              {dialog.message}
            </p>
            <div className="flex gap-md" style={{ justifyContent: 'flex-end' }}>
              <button onClick={handleCancel} className="btn btn-secondary">
                Cancel
              </button>
              {dialog.altLabel && (
                <button onClick={handleAlt} className="btn btn-secondary">
                  {dialog.altLabel}
                </button>
              )}
              <button
                onClick={handleConfirm}
                className="btn btn-primary"
                style={dialog.danger ? { background: 'var(--color-primary)', borderColor: 'var(--color-primary)' } : {}}
                autoFocus
              >
                {dialog.confirmLabel}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext);
